export { applyInParagraphEditOutput } from './applyInParagraphEditOutput';
export type { ApplyInParagraphEditOutputOptions } from './applyInParagraphEditOutput';
export { applyInsertOutput } from './applyInsertOutput';
export type { ApplyInsertOutputOptions } from './applyInsertOutput';
export { applyInsertRowsOutput } from './applyInsertRowsOutput';
export type { ApplyInsertRowsOutputOptions } from './applyInsertRowsOutput';
export {
  applyRemoveColumnsOutput,
  partitionRemoveColumnAnchorsIntoRuns,
} from './applyRemoveColumnsOutput';
export type {
  ApplyRemoveColumnsOutputOptions,
  RemoveColumnAnchorRun,
} from './applyRemoveColumnsOutput';
export { applyRemoveOutput, partitionRemoveAnchorsIntoRuns } from './applyRemoveOutput';
export type { ApplyRemoveOutputOptions, RemoveAnchorRun } from './applyRemoveOutput';
export { applyRemoveRowsOutput, partitionRemoveRowAnchorsIntoRuns } from './applyRemoveRowsOutput';
export type { ApplyRemoveRowsOutputOptions, RemoveRowAnchorRun } from './applyRemoveRowsOutput';
export { applyRemoveTableOutput } from './applyRemoveTableOutput';
export type { ApplyRemoveTableOutputOptions } from './applyRemoveTableOutput';
export { convertTextToDiffSegment } from './convertTextToDiffSegment';
export type { EditOutputWithSource } from './types';

import { applyInParagraphEditOutput } from './applyInParagraphEditOutput';
import { applyInsertOutput } from './applyInsertOutput';
import { applyRemoveOutput } from './applyRemoveOutput';

/**
 * Transforms for applying redline edits (structured AI edit output) to the document.
 */
export const RedlineTransforms = {
  applyInParagraphEditOutput,
  applyInsertOutput,
  applyRemoveOutput,
};
